<template>
<div class="mobile-header-drawer">
    <svg-icon @click="drawer = true" class-name="mobile-more-icon" icon-class="mobile-menu"></svg-icon>

    <moo-drawer custom-class="mobile-drawer" :size="'auto'" :modal-append-to-body="false" direction="btt" :title="$t('我是标题#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1')" :visible.sync="drawer" :with-header="false">
      <div class="mobile-drawer-content">
        <div class="mobile-drawer-header">
          <svg-icon @click="drawer = false" class-name="mobile-more-close" icon-class="mobile-menu-close"></svg-icon>
          <div class="mobile-more-doc-top"></div>
          <div class="mobile-more-doc-icon">
            <svg-icon :icon-class="docTypeIcon"></svg-icon>
          </div>
          <div class="mobile-more-doc-title">
            {{ docInfo.fileName }}
          </div>
          <div class="mobile-more-doc-info">
            {{ docTypeDesc }}
            <div class="creator">{{ docInfo.creator }}</div>
          </div>
          <div class="mobile-more-doc-date">
            {{ docDateDesc }}
          </div>
          <div class="mobile-more-doc-bottom"></div>
        </div>
        <div class="drawer-options">
          <div @click="handleOpen" class="menu-item">
            <img class="mobile-options-icon" src="@/assets/h5/file/menu-open.png" alt="">{{$t("用同程管家打开#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1")}}          </div>
          <div v-if="this.showDownload" @click="handleDownload" class="menu-item">
            <img class="mobile-options-icon" src="@/assets/h5/file/menu-download.png" alt="">{{$t("下载#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1")}}          </div>
        </div>
      </div>
    </moo-drawer>
    <Guide v-if="showGuide"></Guide>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import Guide from "../tip/guide.vue";
import { getDocTypeName } from "../../utils/docTypeName.js";
import { getFileIcon } from "../../utils/docTypeAssets.js";
export default {
  name: "MobileHeader",
  components: {
    Guide
  },
  props: {
    auth: {
      type: String,
      default: "READ"
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    fileId: {
      type: String
    },
    isEditor: {
      type: Boolean
    },
    docInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isWiki: {
      type: Boolean,
      default: false
    },
    folderFileCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      drawer: false,
      showGuide: false,
      is_weixin:
      navigator.userAgent.toLowerCase().match(/micromessenger/i) ==
      "micromessenger",
      is_Android:
      navigator.userAgent.indexOf("Android") > -1 ||
      navigator.userAgent.indexOf("Linux") > -1
    };
  },
  computed: {
    docTypeIcon() {
      return getFileIcon(
        this.docInfo.fileName,
        this.docInfo.type,
        this.docInfo.contentType
      );
    },
    docTypeDesc() {
      const docTypeName =
      getDocTypeName(this.docInfo.fileName, this.docInfo.contentType) + "，";
      let sizeDesc = this.formatBytes(this.docInfo.size ?? 0);
      if (this.docInfo.contentType === "FOLDER") {
        sizeDesc = intl.$t(`共{slot0}个项目#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1`, { slot0: this.folderFileCount });
      }
      return docTypeName + sizeDesc;
    },
    docDateDesc() {
      return (
        intl.$t("最后更新于#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1") +
        this.getFormattedDate(
          this.docInfo.lastModifiedTime ?? this.docInfo.operationTime
        ) + intl.$t("日#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1") + intl.$t("，创建于#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1") +


        this.getFormattedDate(this.docInfo.createTime) + intl.$t("日#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_2"));


    },
    showDownload() {
      return this.auth !== "READ" && !this.isEditor;
    },
    menuDataOptions() {
      if (this.showDownload) {
        return this.menuData;
      } else {
        return this.menuData.filter((item) => item.type !== "download");
      }
    },
    drawerHeight() {
      return this.showDownload ? "30%" : "20%";
    }
  },
  methods: {
    formatBytes(bytes) {
      if (bytes === 0) return "0 B"; // 如果字节大小为 0，直接返回

      const units = ["B", "KB", "MB", "GB", "TB"]; // 单位列表
      const k = 1024; // 1 KB = 1024 B
      const i = Math.floor(Math.log(bytes) / Math.log(k)); // 计算单位索引

      const size = bytes / Math.pow(k, i); // 转换为相应单位的大小
      return `${size.toFixed(2)} ${units[i]}`; // 保留小数点最多两位
    },
    getFormattedDate(timestamp) {
      const date = new Date(timestamp);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      const currentYear = new Date().getFullYear();
      if (year === currentYear) {
        return `${month}/${day}`;
      }
      return `${year}/${month}/${day}`;
    },
    openInnerAppLink() {
      const cloudLink = `toca://clouddisk/?fileId=${this.fileId}`;
      window.open(cloudLink);
    },
    handleOpen() {
      if (this.isWiki) {
        //知识库场景
        setTimeout(() => {
          window.parent.postMessage("handleOpen", "*");
        }, 10);
      } else if (this.is_weixin) {
        // this.showGuide = true
        window.location.href = `https://guanjia.tcent.cn/clouddisk/${this.fileId}`;
      } else {
        this.openInnerAppLink();
      }
      this.drawer = false;
    },
    handleDownload() {
      if (
      this.is_weixin &&
      navigator.userAgent.toLowerCase().match(/wxwork/i) == "wxwork" &&
      !this.is_Android)
      {
        this.$message({
          message: intl.$t("可在浏览器打开此网页来下载文件。#!!!#src/pages/H5/Cloud/components/drawer/mobileHeader.vue_1"),
          type: "warning"
        });
        return;
      }
      this.$emit("download", this.fileId, true);
      this.drawer = false;
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.$emit("handleViewVisible", "flex");
      } else {
        this.$emit("handleViewVisible", "flex");
      }
    }
  }
};
</script>

<style lang="scss">
.mobile-header-drawer {
  display: flex;
  align-items: center;
  justify-content: center;

  .mobile-more-icon {
    width: 20px;
    height: 20px;
  }

  .mobile-drawer {
    border-radius: 16px 16px 0 0;
  }

  .moo-drawer__body {
    border-radius: 16px 16px 0 0;
  }

  .mobile-drawer-content {
    background-color: #f5f7fc;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 16px 24px 16px;

    .mobile-drawer-header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .mobile-more-close {
        position: absolute;
        top: 13px;
        right: 16px;
        width: 28px;
        height: 28px;
        // background-color: #fff;
      }

      .mobile-more-doc-top {
        width: 100%;
        height: 32px;
      }

      .mobile-more-doc-icon {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          width: 48px;
          height: 48px;
        }
      }

      .mobile-more-doc-title {
        margin-top: 16px;
        line-height: 22px;
        font-weight: 500;
        font-size: 16px;
        color: #222329;
        letter-spacing: 0;
        text-align: center;
      }

      .mobile-more-doc-info {
        line-height: 21px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #a2a4b0;
        letter-spacing: 0;
        text-align: center;

        .creator {
          display: inline-block;
          height: 21px;
          background: #eceeff;
          border-radius: 4px;
          color: #5c70ff;
          padding: 0px 6px;
          font-weight: 500;
          font-size: 11px;
        }
      }

      .mobile-more-doc-date {
        margin-top: 4px;
        line-height: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #a2a4b0;
        letter-spacing: 0;
        text-align: center;
      }

      .mobile-more-doc-bottom {
        width: 100%;
        height: 32px;
      }
    }

    .drawer-options {
      width: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 10px;

      .menu-item {
        height: 54px;
        width: 100%;
        display: flex;
        flex-flow: row;
        font-size: 16px;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px;
        cursor: pointer;

        .mobile-options-icon {
          width: 18px;
          height: 18px;
          margin-right: 16px;
        }
      }
    }
  }
}

/* Your scoped styles here */
</style>
